export const lg_header_feature = {
  lg_header_feature_th: {
    pricingplans: "เริ่มต้นใช้งานฟรี อัปเกรดเมื่อคุณพร้อม",
    title1: "เลือกแผนที่เหมาะสำหรับคุณ",
    title2:
      "ข้อมูลการประชุมทั้งหมดถูกจัดเก็บอย่างปลอดภัยในประเทศไทย และเป็นไปตามกฎหมาย PDPA",
    titlefree: "ฟรี",
    titlepro: "โปร",
    titlebusiness: "ธุรกิจ",
    titleenterprise: "องค์กร",
    pricesubtitlefree: "แผนฟรี",
    subtitlefree: "/ เดือน",
    subtitlefree_2: "/ ปี",
    pricesubtitlepro: "150",
    subtitlepro: " ผู้ใช้ /เดือน",
    subtitleenterprise: "สำหรับลูกค้าธุรกิจ ปรับแต่งได้",
    lifree1: "ผู้ร่วมประชุม สูงสุด 25 คน",
    lifree2: "ไม่จำกัดการประชุมสูงสุด 50 นาที",
    lifree3: "ทีมแชท",
    lifree4: "ไม่ต้องใช้บัตรเครดิต",
    lipro1: "ผู้ร่วมประชุม สูงสุด 150 คน",
    lipro2: "ไม่จำกัดการประชุมสูงสุด 33 ชั่วโมง",
    lipro3: "ทีมแชท",
    lipro4: "บันทึกการประชุม",
    buttonfree: "สมัครตอนนี้",
    buttonpro: "ติดต่อเรา",
    lienterprise1: "ผู้ร่วมประชุม สูงสุด 150 คน/ประชุม 4 ชม",
    lienterprise2: "แชร์หน้าจอ",
    lienterprise3: "แชท",
    lienterprise4: "กำหนด password ก่อนเข้าห้องประชุม",
    lienterprise5: "บันทึกการประชุม",
    lienterprise6: "คำบรรยาย",
    buttonenterprise: "ติดต่อเรา",
    get_start: "เริ่มต้นใช้งาน",
    explore_features: "ฟีเจอร์",
    details1:
      "ประชุมผ่านวิดีโอออนไลน์สำหรับธุรกิจของคุณด้วยแผนฟรีและแผนโปรของเรา ค้นพบคุณสมบัติและ",
    subdetails11: "ราคาที่เหมาะกับความต้องการของคุณ",
    subdetails12: "เพื่อยกระดับการทำงานของคุณ",
    details2: "แผนฟรี",
    subdetails21: "ปัจจุบันของเรามีการประชุมไม่จำกัดเวลาสำหรับ",
    subdetails22: "ผู้เข้าร่วมสูงสุด 10 คน",
    subdetails23: "พร้อม",
    subdetails24: "วิดีโอและเสียงระดับ HD",
    subdetails25: "และ",
    subdetails26: "การแชร์หน้าจอของโฮสต์",
    subdetails27: "ซึ่งเหมาะสำหรับการประชุมขนาดเล็กและการใช้งานส่วนตัว",
    btn_signup: "สมัครสมาชิก",
    title_plan: "แผนฟรีและแผนโปร",
    details3: "สำหรับธุรกิจที่มีความต้องการเพิ่มเติม",
    subdetails31: "แผนโปร",
    subdetails32: "ของเรามีฟีเจอร์เพิ่มเติม เช่น",
    subdetails33:
      "ห้องร้องรับ การโหวตและการบันทึกประชุม การถอดเสียง ผู้จดบันทึกการประชุม และ ปลั๊กอินอื่นๆ",
    subdetails34:
      "สิ่งเหล่านี้จะช่วยให้มั่นใจว่าการประชุมทุกครั้งจะมีประสิทธิภาพ มีการบันทึกไว้อย่างครบถ้วนและปลอดภัย",
    details4: "ติดต่อเราเพื่ออัปเกรดเป็นโปร",
    subdetails41:
      "และปลดล็อคฟีเจอร์ของเราอย่างเต็มรูปแบบ เพื่อเพิ่มประสิทธิภาพในการประชุมของคุณ",
    titlefreeplan: "แผนฟรี",
    titleproplan: "แผนโปร",
    titlepricingplan: "ราคา",
    titlefreeplandetails1: "รองรับผู้เข้าร่วมได้สูงสุด 10 คน",
    titlefreeplandetails2: "จำกัดระยะเวลาการประชุมที่40 นาทีต่อครั้ง",
    titlefreeplandetails3: "แชร์หน้าจอ แชท และแชร์ไฟล์",
    titleproplandetails1: "แผนโปร",
    titleproplandetails2:
      "ของเรา เหมาะสำหรับทีมขนาดใหญ่และธุรกิจทุกประเภท มีทุกอย่างในแผนฟรีพร้อมด้วย",
    titlepricingplandetails1: "แผนโปร",
    titlepricingplandetails2: "เริ่มต้นเพียง",
    titlepricingplandetails3: "$11/เดือน และสามารถปรับเปลี่ยน",
    titlepricingplandetails4:
      "ตามที่คุณต้องการได้ ติดต่อเราวันนี้เพื่อดูข้อเสนอ",
    titlepricingplandetails5: "ราคาของคุณ",
    titlefreeplanoptions1: "ผู้เข้าร่วมสูงสุด 10 คน",
    titlefreeplanoptions2: "การแบ่งปันหน้าจอเฉพาะโฮสต์",
    titlefreeplanoptions3: "ทีมแชทแบบกลุ่ม",
    titleproplanoptions1:
      "รองรับผู้เข้าร่วมได้สูงสุด 50 คน ไม่จำกัดระยะเวลาต่อการประชุม",
    titleproplanoptions2: "รวมเวลาในการบันทึกวิดีโอ 60 นาทีต่อเดือน",
    titleproplanoptions3: "รายงานการประชุมโดย ทนายความที่ปรึกษา (บริการเสริม)",
    titleproplanoptions4: "แชร์หน้าจอ แชท และแชร์ไฟล์",
    titleproplanoptions5: "ห้องรองรับ",
    titleproplanoptions6:
      "การบันทึกและการถอดเสียงพูดด้วยระบบคลาวด์ (ตัวเลือกเสริม)",
    titleproplanoptions7: "ผู้จดบันทึกการประชุม (ตัวเลือกเสริม)",
    coming_soon: "เร็วๆ นี้",
    buy_now: "ซื้อ",
    titlebusinessplan: "แผนธุรกิจ",
    titlebusinessplanoptions1:
      "รองรับผู้เข้าร่วมได้สูงสุด 100 คน ไม่จำกัดระยะเวลาต่อการประชุม",
    titlebusinessplanoptions2: "รวมเวลาในการบันทึกวิดีโอ 120 นาทีต่อเดือน",
    titlebusinessplanoptions3:
      "โหวตภายในห้องประชุม พร้อมดู ผลโหวตการประชุมย้อนหลัง",
    titlebusinessplanoptions4: "แชร์หน้าจอ แชท และแชร์ไฟล์",
    titlecusstomplan: "แผนองค์กร",
    title_custom: "ตามการใช้งาน",
    titlecusstomplanoptions1: "ไม่จำกัดจำนวนผู้เข้าร่วม และ ระยะเวลาการประชุม",
    titlecusstomplanoptions2: "โควตาการบันทึกวิดีโอรายเดือนตามการใช้งาน",
    titlecusstomplanoptions3:
      "ระบบโหวตภายในห้องประชุม พร้อมผลรายงานที่ปรับแต่งได้",
    unlimited: "ไม่จำกัด",
    up_to_ten: "สูงสุด 10 คน",
    up_to_fifty: "สูงสุด 50 คน",
    up_to_hundred: "สูงสุด 100 คน",
    minite_per_session: "40 นาที/ครั้ง",
    sixty_minute_per_month: "60 นาที",
    hundred_twenty_minute_per_month: "120 นาที",
    discounted_rate: "ราคาพิเศษ",
    record_bath_per_min: "฿0.40 / นาที",
    basic_email: "อีเมลทั่วไป",
    standard_email: "อีเมลมาตรฐาน",
    priority: "อีเมลด่วน",
    dedicated: "อีเมลแบบเจาะจง",
    bath_per_meeting: "฿10,000+/ประชุม",
    header_table1: "จำนวนผู้เข้าร่วมต่อการประชุม",
    header_table2: "ระยะเวลาการประชุมต่อครั้ง",
    header_table3: "โควตาการบันทึกวิดีโอต่อเดือน",
    header_table4: "ค่าบันทึกวิดีโอเพิ่มเติม",
    header_table5: "แชร์หน้าจอ แชท และแชร์ไฟล์",
    header_table6: "โหวตภายในห้องประชุม",
    header_table7: "ผลการประชุม",
    header_table8: "การสตรีม RTMP",
    header_table9: "การจัดเก็บข้อมูลในไทย (PDPA)",
    header_table10: "การซัพพอร์ต",
    header_table11: "รายงานการประชุมโดยทนายที่ปรึกษา (บริการเสริม)",
    title_additional_information: "ข้อมูลเพิ่มเติม",
    question1: "นโยบายการใช้งาน",
    subquestion1: "แพ็กเกจแบบชำระเงินสามารถใช้งานการประชุมได้ไม่จำกัดเวลา",
    subquestion1_2:
      "ทั้งนี้ เพื่อให้ระบบทำงานได้อย่างมีประสิทธิภาพ การประชุมที่ไม่มีการใช้งานหรือเปิดทิ้งไว้อย่างต่อเนื่อง อาจถูกจำกัดในการใช้งานได้",
    question2: "ข้อจำกัดของแพ็กเกจ",
    subquestion2:
      "แต่ละแพ็กเกจมีการจำกัดจำนวนผู้เข้าร่วมต่อการประชุม และจำกัดเวลาบันทึกต่อเดือน",
    subquestion2_2:
      "โควตาการบันทึกจะถูกรีเซ็ตใหม่ในแต่ละรอบบิล และไม่สามารถสะสมหรือนำใช้ในเดือนถัดไปได้",
    question3: "บริการเสริมเพิ่มเติม",
    subquestion3: "บริการเสริมเพื่อเพิ่มมีดังนี้",
    subquestion3_2:
      "รายงานการประชุมโดยทนายความที่ปรึกษากฎหมาย (เริ่มต้น ฿10,000 ต่อครั้ง)",
    subquestion3_3:
      "RTMP Livestreaming (สำหรับแพ็กเกจ Enterprise เท่านั้น คิดค่าบริการตามการใช้งาน)",
    question4: "นโยบายความเป็นส่วนตัว (PDPA)",
    subquestion4:
      "ข้อมูลการประชุมทั้งหมดถูกจัดเก็บอย่างปลอดภัยบนเซิร์ฟเวอร์ในประเทศไทย?",
    subquestion4_2:
      "Dmeets ออกแบบโดยให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลตาม PDPA",
    subquestion4_3: "",
    question5: "การชำระเงิน",
    subquestion5: "แพ็กเกจจะเรียกเก็บค่าบริการล่วงหน้า (รายเดือนหรือรายปี)",
    subquestion5_2:
      "สามารถยกเลิกได้ตลอดเวลา โดยยังสามารถใช้งานได้จนสิ้นสุดรอบบิล",
    subquestion5_3:
      "บริษัทขอสงวนสิทธิ์ในการไม่คืนเงินสำหรับระยะเวลาที่ได้มีการใช้งานไปแล้ว",
    question6: "การปฏิบัติตาม PDPA และความเป็นส่วนตัว",
    subquestion6:
      "Dmeets จัดเก็บข้อมูลการประชุมทั้งหมดบนเซิร์ฟเวอร์ภายในประเทศไทย และปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) อย่างเคร่งครัด ไม่มีการส่งข้อมูลการประชุมออกนอกประเทศ",
    subquestion6_2: "",
    question7: "นโยบายการเรียกเก็บเงินและการคืนเงิน",
    subquestion7:
      "ทุกแผนแบบชำระเงินจะถูก เรียกเก็บล่วงหน้าแบบรายเดือนหรือรายปี",
    subquestion7_2:
      "Dmeets ไม่คืนเงิน ในกรณีที่มีการยกเลิกกลางรอบบิล หรือไม่ได้ใช้งานตามที่ชำระไว้",
    upgrade_now: "อัปเกรดตอนนี้",
    manage_billing: "จัดการการชำระเงิน",
    manage_billing_details:
      "คุณกำลังใช้งานแพ็กเกจฟรีอยู่ในขณะนี้ อัปเกรดเพื่อบันทึกการประชุมและใช้ฟีเจอร์อื่นๆอีกมากมาย",
    recommend: "แนะนำ",
    freeplan_details: "เหมาะสำหรับการใช้ประชุมทั่วไป",
    proplan_details:
      "สำหรับทีมที่ต้องการเวลาประชุมที่ยืดหยุ่นและการบันทึกการประชุม",
    businessplan_details:
      "ออกแบบมาสำหรับทีมที่ต้องการการประชุมแบบเต็มระบบพร้อมผลรายงานการโหวต",
    enterpriseplan_details:
      "สำหรับองค์กรที่ต้องการควบคุมมากขึ้น และรองรับการใช้งานในเชิงลึก",
    still_have_questions: "มีคำถามเพิ่มเติม?",
    contact_support: "ติดต่อทีมงาน",
    monthly: "รายเดือน",
    yearly: "รายปี",
    fp_badge: "ฟีเจอร์ทั้งหมด",
    fp_title: "ฟีเจอร์ครบครัน\nสำหรับการประชุมที่มีคุณภาพ",
    fp_subtitle: "ทุกสิ่งที่คุณต้องการในที่เดียว",
    fp_hd_title: "การประชุมวิดีโอ HD",
    fp_hd_desc:
      "ประสบการณ์ประชุมระดับพรีเมียมด้วยวิดีโอและเสียง HD คุณภาพสูง รองรับผู้เข้าร่วมพร้อมกันสูงสุด 500 คน",
    fp_screen_title: "แชร์หน้าจอและเอกสาร",
    fp_screen_desc:
      "แชร์หน้าจอ แอปพลิเคชัน หรือเอกสารด้วยคลิกเดียว พร้อมโหมดคำอธิบายสำหรับการนำเสนอที่มีประสิทธิภาพ",
    fp_chat_title: "แชทและแชร์ไฟล์",
    fp_chat_desc: "การสื่อสารแชทแบบเรียลไทม์พร้อมแชร์ไฟล์และเอกสารทันที",
    fp_record_title: "บันทึกการประชุม",
    fp_record_desc: "ค้นหาและดาวน์โหลดการบันทึกการประชุมได้ทุกเวลา",
    fp_voting_title: "โหวตในการประชุม",
    fp_voting_desc:
      "ระบบโหวตแบบเรียลไทม์พร้อมผลลัพธ์ทันที เหมาะสำหรับการตัดสินใจในการประชุมคณะกรรมการและทีม",
    fp_report_title: "รายงานการโหวต",
    fp_report_desc: "ติดตามผลการโหวต แสดงผลการลงคะแนน และออกรายงานอัตโนมัติ",
    fp_premium_title: "ฟีเจอร์พรีเมียมสำหรับองค์กรขนาดใหญ่",
    fp_premium_subtitle: "บริการเฉพาะทางสำหรับองค์กรขนาดใหญ่",
    fp_legal_title: "รายงานการประชุมโดยที่ปรึกษากฎหมาย",
    fp_legal_desc:
      "รายงานการประชุมระดับมืออาชีพโดยทนายความที่ปรึกษา เหมาะสำหรับ:",
    fp_legal_item1: "การประชุมคณะกรรมการบริหาร",
    fp_legal_item2: "การประชุมผู้ถือหุ้น",
    fp_legal_item3: "การประชุมที่ต้องการเอกสารที่มีผลทางกฎหมาย",
    fp_legal_item4: "องค์กรที่ต้องการบันทึกการประชุมอย่างเป็นทางการ",
    fp_support_title: "ซัพพอร์ตระดับพรีเมียม",
    fp_support_desc: "แผน Enterprise ประกอบด้วย:",
    fp_support_item1: "ซัพพอร์ตอีเมลลำดับความสำคัญสูง",
    fp_support_item2: "ที่ปรึกษากฎหมายเฉพาะทาง",
    fp_support_item3: "คำปรึกษาการตั้งค่าการประชุม",
    fp_support_item4: "รับประกัน SLA Uptime 99.9%",
    fp_cta_title: "พร้อมลองฟีเจอร์ทั้งหมดแล้วหรือยัง?",
    fp_cta_subtitle: "เริ่มฟรี ไม่ต้องใช้บัตรเครดิต",
    fp_cta_start: "เริ่มฟรี",
    fp_cta_contact: "ติดต่อเรา",
  },
  lg_header_feature_en: {
    pricingplans: "Start Free. Upgrade When You’re Ready.",
    title1: "Choose your preferred plan.",
    title2: "All meeting data is stored securely in Thailand.",
    titlefree: "Free",
    titlepro: "Pro",
    titlebusiness: "Business",
    titleenterprise: "Enterprise",
    pricesubtitlefree: "Free",
    subtitlefree: "/ month",
    subtitlefree_2: "/ year",
    pricesubtitlepro: "150",
    subtitlepro: " Users /Month",
    subtitleenterprise: "Customizable for Business Customers",
    lifree1: "Host up to 25 attendees",
    lifree2: "Unlimited meetings for up to 50 minutes",
    lifree3: "Team Chat",
    lifree4: "No credit card required",
    lipro1: "Host up to 150 attendees",
    lipro2: "Unlimited meetings for up to 33 hours",
    lipro3: "Team Chat",
    lipro4: "Record Minutes of Meeting",
    buttonfree: "Register Now",
    buttonpro: "Contact Us",
    lienterprise1: "Participants up to 150 people/4 hours meeting",
    lienterprise2: "Share screen",
    lienterprise3: "Chat",
    lienterprise4: "Set passwords for meeting rooms",
    lienterprise5: "Record Meetings",
    lienterprise6: "With subtitles",
    buttonenterprise: "Contact Us",
    get_start: "Get Started",
    explore_features: "Features",
    details1: "Unlock seamless video conferencing for your business with our",
    subdetails11: "free and pro",
    subdetails12: "plans. Discover the features and",
    subdetails13: "pricing that fit your needs",
    subdetails14: "and take your remote collaboration to the next level.",
    details2: "Our current",
    subdetails21: "Free Plan",
    subdetails22: "offers",
    subdetails23: "unlimited meetings",
    subdetails24: "for up to",
    subdetails25: "10 participants,",
    subdetails26: "with HD video and audio, and",
    subdetails27: "host screen sharing.",
    subdetails28:
      "It's the perfect solution for small meetings and personal use.",
    btn_signup: "Sign Up",
    title_plan: "Free and Pro Plans",
    details3: "For businesses with more advanced needs, our",
    subdetails31: "Pro Plan",
    subdetails32: "includes additional features such as a",
    subdetails33:
      "waiting room, voting and polling, recording, transcription, a professional minute-taker and other plugins.",
    subdetails34:
      "This ensures that every meeting is productive, well-documented, and all key points are accurately captured.",
    details4: "Contact us to upgrade to Pro",
    subdetails41:
      "and unlock the full potential of our platform, enhancing the productivity and efficiency of your meetings.",
    titlefreeplan: "Free Plan",
    titleproplan: "Pro",
    titlepricingplan: "Pricing",
    titlefreeplandetails1: "Up to 10 participants",
    titlefreeplandetails2: "40-minutes meeting limit per session",
    titlefreeplandetails3: "Screen sharing, chat,and file sharing",
    titleproplandetails1:
      "The pro plan unlocks advanced features for larger teams and businesses. Our",
    titleproplandetails2: "free plan plus.",
    titlepricingplandetails1: "The",
    titlepricingplandetails2: "pro plan",
    titlepricingplandetails3: "can start as low as",
    titlepricingplandetails4: "$11/month.",
    titlepricingplandetails5: "Our Pro plans",
    titlepricingplandetails6: "can be tailored",
    titlepricingplandetails7: "for each of our customers, contact us today to",
    titlepricingplandetails8: "get your price.",
    titlefreeplanoptions1: "Up to 10 participants",
    titlefreeplanoptions2: "Host-only Screen sharing",
    titlefreeplanoptions3: "Public Team Chat",
    titleproplanoptions1: "Up to 50 participants, unlimited session time",
    titleproplanoptions2: "60 recording minutes per month",
    titleproplanoptions3: "Optional legal meeting minutes add-on",
    titleproplanoptions4: "Screen sharing, chat, and file sharing",
    titleproplanoptions5: "Waiting room",
    titleproplanoptions6: "Recording and Transcription (optional)",
    titleproplanoptions7: "Professional minute-taker (optional)",
    coming_soon: "Coming Soon",
    buy_now: "Buy Now",
    titlebusinessplan: "Business",
    titlebusinessplanoptions1: "Up to 100 participants, unlimited session time",
    titlebusinessplanoptions2: "120 recording minutes per month",
    titlebusinessplanoptions3:
      "In-meeting voting, plus access to meeting report",
    titlebusinessplanoptions4: "Screen sharing, chat, and file sharing",
    titlecusstomplan: "Enterprise Plan",
    title_custom: "Custom",
    titlecusstomplanoptions1: "Unlimited participants and session time",
    titlecusstomplanoptions2: "Flexible monthly quotas recording minutes",
    titlecusstomplanoptions3: "In-meeting voting with customise report",
    unlimited: "Unlimited",
    up_to_ten: "Up to 10",
    up_to_fifty: "Up to 50",
    up_to_hundred: "Up to 100",
    minite_per_session: "40 mins/session",
    sixty_minute_per_month: "60 mins",
    hundred_twenty_minute_per_month: "120 mins",
    discounted_rate: "Discounted rate",
    record_bath_per_min: "฿0.40 / min",
    basic_email: "Basic Email",
    standard_email: "Standard Email",
    priority: "Priority",
    dedicated: "Dedicated",
    bath_per_meeting: "฿10,000+/meeting",
    header_table1: "Participants per meeting",
    header_table2: "Meeting Limit",
    header_table3: "Monthly recording credit",
    header_table4: "Extra recording cost",
    header_table5: "Screen sharing, chat, file sharing",
    header_table6: "In-meeting voting",
    header_table7: "Meeting report",
    header_table8: "RTMP streaming",
    header_table9: "PDPA compliance",
    header_table10: "Support Level",
    header_table11: "Official meeting minutes (Add-on)",
    title_additional_information: "Additional Information",
    question1: "Fair Use Policy",
    subquestion1: "Unlimited meeting time is included in all paid plans.",
    subquestion1_2:
      "To ensure consistent performance for all users, unattended, idle, or continuously running meetings may be limited.",
    question2: "Plan Limits",
    subquestion2:
      "Each plan includes participant limits and monthly recording minutes.",
    subquestion2_2:
      "Recording usage resets each billing cycle. Unused minutes do not roll over.",
    question3: "Add-On Services",
    subquestion3: "Optional services are available to enhance your meetings.",
    subquestion3_2:
      "Official meeting minutes by licensed Thai legal advisors (starting at ฿10,000 per session)",
    subquestion3_3:
      "RTMP livestreaming (Enterprise plan only, usage-based pricing)",
    question4: "Data Privacy (PDPA)",
    subquestion4:
      "All meeting data is securely stored on servers located in Thailand.",
    subquestion4_2:
      "Dmeets is built with a strong commitment to PDPA-aligned data protection.",
    subquestion4_3: "",
    question5: "Billing",
    subquestion5: "All plans are billed in advance (monthly or annually).",
    subquestion5_2:
      "You may cancel anytime, with access remaining until the end of the billing cycle.",
    subquestion5_3:
      "The company reserves the right to withhold refunds for any period during which the service has already been used.",
    question6: "PDPA Compliance & Data Privacy",
    subquestion6:
      "Dmeets stores all your meetings securely on servers located in Thailand.",
    subquestion6_2:
      "We are fully compliant with the Personal Data Protection Act (PDPA) and do not transfer your meeting information outside the country.",
    question7: "Billing & Refund Policy",
    subquestion7: "All paid plans are billed in advance (monthly or annually).",
    subquestion7_2:
      "We do not offer refunds for unused time or partial usage. You may cancel at any time, and your plan will remain active until the end of the current billing cycle.",
    upgrade_now: "Upgrade Now",
    manage_billing: "Manage Billing",
    manage_billing_details:
      "You’re currently on the Free Plan. Upgrade to access more features and recording time.",
    recommend: "Recommend",
    freeplan_details:
      "Perfect for getting started with simple, everyday meetings.",
    proplan_details:
      "For teams that need longer meetings and recording flexibility.",
    businessplan_details:
      "Built for teams that run structured meetings with collaboration and voting insights.",
    enterpriseplan_details:
      "Tailored solutions for organizations that need scale, control, and customization.",
    still_have_questions: "Still have questions?",
    contact_support: "Contact our support team",
    monthly: "Monthly",
    yearly: "Annually",
    fp_badge: "All Features",
    fp_title: "Complete Feature Set\nFor Productive Meetings",
    fp_subtitle: "Everything you need in one place",
    fp_hd_title: "HD Video Meetings",
    fp_hd_desc:
      "Premium meeting experience with crystal-clear HD video and audio. Support up to 500 participants simultaneously with industry-leading quality.",
    fp_screen_title: "Screen Sharing & Documents",
    fp_screen_desc:
      "Share your screen, applications, or documents with one click. Features annotation mode for effective presentations and collaboration.",
    fp_chat_title: "Chat & File Sharing",
    fp_chat_desc:
      "Real-time chat communication with instant file and document sharing. Searchable conversation history for easy reference.",
    fp_record_title: "Meeting Recording",
    fp_record_desc: "Search and review recordings anytime, anywhere.",
    fp_voting_title: "In-Meeting Voting",
    fp_voting_desc:
      "Real-time voting system with instant results. Perfect for decision-making in board meetings and team discussions.",
    fp_report_title: "Meeting Vote Report",
    fp_report_desc:
      "Generate detailed voting results automatically. Track participation rates, visualize vote distribution, and export comprehensive reports for every poll conducted during your meetings.",
    fp_premium_title: "Premium Features for Enterprise",
    fp_premium_subtitle: "Specialized services for large organizations",
    fp_legal_title: "Legal Advisor Meeting Minutes",
    fp_legal_desc:
      "Professional meeting minutes prepared by licensed lawyers and legal advisors. Perfect for:",
    fp_legal_item1: "Board of Directors meetings",
    fp_legal_item2: "Shareholder meetings",
    fp_legal_item3: "Meetings requiring legally binding documentation",
    fp_legal_item4: "Organizations needing official meeting records",
    fp_support_title: "Premium Support",
    fp_support_desc: "Enterprise plan includes:",
    fp_support_item1: "Priority email support",
    fp_support_item2: "Dedicated Legal Advisor",
    fp_support_item3: "Meeting setup consultation",
    fp_support_item4: "99.9% uptime SLA guarantee",
    fp_cta_title: "Ready to Try All Features?",
    fp_cta_subtitle: "Start free, no credit card required",
    fp_cta_start: "Start Free",
    fp_cta_contact: "Contact Us",
  },
};
